import { Controller } from "@hotwired/stimulus";

const openDebugKeys = new Set<string>();

export default class extends Controller<HTMLElement> {
    static targets = ["content", "trigger"];
    static values = {
        key: String,
    };

    declare readonly contentTarget: HTMLElement;
    declare readonly hasContentTarget: boolean;
    declare readonly triggerTarget: HTMLElement;
    declare readonly hasTriggerTarget: boolean;
    declare readonly keyValue: string;
    declare readonly hasKeyValue: boolean;

    private suppressNextClick = false;

    connect(): void {
        this.applyOpenState(openDebugKeys.has(this.stateKey()));
    }

    toggleFromPointer(event: PointerEvent): void {
        if (event.button !== 0) {
            return;
        }

        this.suppressNextClick = true;
        window.setTimeout(() => {
            this.suppressNextClick = false;
        }, 350);
        this.toggle(event);

        if (this.hasTriggerTarget) {
            this.triggerTarget.focus({ preventScroll: true });
        }
    }

    toggleFromClick(event: Event): void {
        if (this.suppressNextClick) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }

        this.toggle(event);
    }

    toggleFromKeyboard(event: KeyboardEvent): void {
        if (event.repeat) {
            return;
        }

        this.toggle(event);
    }

    private isOpen(): boolean {
        return this.element.dataset.ticketEmailDebugOpen === "true";
    }

    private toggle(event: Event): void {
        event.preventDefault();
        event.stopPropagation();

        const nextOpen = !this.isOpen();
        const stateKey = this.stateKey();

        if (nextOpen) {
            openDebugKeys.add(stateKey);
        } else {
            openDebugKeys.delete(stateKey);
        }

        this.applyOpenState(nextOpen);
    }

    private applyOpenState(open: boolean): void {
        this.element.dataset.ticketEmailDebugOpen = open ? "true" : "false";

        if (this.hasTriggerTarget) {
            this.triggerTarget.setAttribute("aria-expanded", open ? "true" : "false");
        }

        if (this.hasContentTarget) {
            this.contentTarget.hidden = !open;
        }
    }

    private stateKey(): string {
        if (this.hasKeyValue && this.keyValue) {
            return this.keyValue;
        }

        return "default";
    }
}
